import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo } from 'react';
import MaskedInput from 'react-text-mask';
import { Input, Label } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import { formFieldWrapper } from '../formFieldWrapper';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const BaseMaskedInputField = ({ elmId, value, onChange, onBlur, placeholder, label, inputLabel, normalizeOnBlur, normalizeOnChange, showError, fluid = true, mask, compact = false, className, guide, disabled, focused, suffix, ...rest }) => {
    const [hasFocus, setHasFocus] = React.useState(focused);
    const [showSuffix, setShowSuffix] = React.useState(!!suffix);
    const onChangeNew = useCallback((e) => {
        if (normalizeOnChange) {
            e.target.value = normalizeOnChange(e.target.value);
        }
        onChange?.(e);
    }, [onChange, normalizeOnChange]);
    const onBlurNew = useCallback((e) => {
        if (normalizeOnBlur) {
            e.target.value = normalizeOnBlur(e.target.value);
            onBlur?.(e);
            onChange?.(e);
        }
        else {
            onBlur?.(e);
        }
        setHasFocus(false);
    }, [onBlur, normalizeOnBlur, onChange]);
    useEffect(() => {
        if (focused && !!suffix && !hasFocus) {
            setHasFocus(true);
            setShowSuffix(false);
        }
    }, [suffix, focused, hasFocus]);
    useEffect(() => {
        if (!!suffix && !showSuffix) {
            setShowSuffix(true);
        }
    }, [suffix, showSuffix]);
    const maskNew = useMemo(() => {
        if (!suffix)
            return mask;
        const addSuffix = (mask) => {
            if (showSuffix) {
                return suffix ? [...mask, ' ', suffix] : mask;
            }
            return mask;
        };
        if (typeof mask === 'function') {
            return (value) => {
                const newMask = mask(value);
                return addSuffix(newMask);
            };
        }
        return addSuffix(mask);
    }, [showSuffix, mask, suffix]);
    return (_jsx(Input, { "data-elm-id": `${elmId}_input`, value: value, onChange: onChangeNew, onBlur: onBlurNew, error: showError, placeholder: placeholder, fluid: fluid, disabled: disabled, className: cx(className, {
            compact,
            labeled: inputLabel,
        }), label: typeof inputLabel === 'string' ? (_jsx(Label, { children: inputLabel })) : (inputLabel), input: _jsx(MaskedInput, { name: rest.name, mask: maskNew, guide: guide, placeholder: placeholder || label, value: value, onBlur: onBlurNew, onChange: onChangeNew, disabled: disabled, "aria-label": `${elmId}_input`, className: cx('masked-input') }), ...rest }));
};
export default formFieldWrapper((fieldProps, showError) => (_jsx(BaseMaskedInputField, { ...fieldProps, showError: showError })));
//# sourceMappingURL=index.js.map